import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import DisclaimerBanner from './components/DisclaimerBanner';
import Home from './pages/Home';
import LoginChoice from './pages/LoginChoice';
import Login from './pages/Login';
import PeopleLogin from './pages/PeopleLogin';
import Search from './pages/Search';
import ServiceDetail from './pages/ServiceDetail';
import RegisterService from './pages/RegisterService';
import MyServices from './pages/MyServices';
import Admin from './pages/Admin';
import Emergency from './pages/Emergency';
import '@/App.css';

// Protected Route Component
const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function AppRoutes() {
  return (
    <div className="App">
      <DisclaimerBanner variant="compact" />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginChoice />} />
        <Route path="/login/provider" element={<Login />} />
        <Route path="/login/people" element={<PeopleLogin />} />
        <Route path="/search" element={<Search />} />
        <Route path="/service/:id" element={<ServiceDetail />} />
        <Route path="/emergency" element={<Emergency />} />
        <Route
          path="/register-service"
          element={
            <ProtectedRoute>
              <RegisterService />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-services"
          element={
            <ProtectedRoute>
              <MyServices />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute adminOnly={true}>
              <Admin />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
